export default "__VITE_ASSET__BSkPY0vF__"